import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { SlideoverReducerStateIdKeys, SlideoverStateReducerState } from "./reducer_interface";

const CustomerProfileModals = {
  CUSTOMER_PROFILE_MEMBERSHIP_DETAILS: {},
  CUSTOMER_PROFILE_DISCOUNT_DETAILS: {},
  CALENDAR_VIEW_FILTERS: {},
  BOOKING_DETAILS_VIEW: {},
};

// Define the initial state using that type
const intialRootState: SlideoverStateReducerState = {
  ...CustomerProfileModals,
};

export const rootStateSlice = createSlice({
  name: "slideover_states",
  initialState: intialRootState,
  reducers: {
    setSlideoverStateData: (state, action: PayloadAction<{ key: SlideoverReducerStateIdKeys; data: any }>) => {
      state[action.payload.key as SlideoverReducerStateIdKeys] = action.payload.data;
    },
  },
});

export const { setSlideoverStateData } = rootStateSlice.actions;

export default rootStateSlice.reducer;
